<div>
  <img
    class="float-end"
    src="assets/images/icons/default_icons/icon-close.png"
    alt="icon-close"
    (click)="OnClose()"
    [ngStyle]="{ cursor: 'pointer' }"
  />
</div>
<h1 mat-dialog-title>Documents Uploaded</h1>
<div *ngIf="data?.length == 0" class="attachment">
  <h5>No Data Available</h5>
</div>

<div *ngFor="let item of documentPresent | keyvalue" class="marT8" style="padding-left: 25px">
  <span *ngIf="item.value">
    <img id="icon-tickEducation" src="assets/images/icon_color_success.png" alt="icon-tick" />
  </span>
  <span *ngIf="!item.value">
    <img id="icon-crossLocation" src="assets/images/icon_color_error.png" alt="icon-wrong" />
  </span>
  <span class="marL10">{{ item.key }}</span>
</div>
